import React from "react"
import style from "./NavBar.module.css"
import { NavLink } from "react-router-dom";


const NavBar = () => {
    return (
      <nav className={style.navbar}>
        <div className={style.navLeft}>
          <NavLink to="/" className={style.logo}>StayWithMe</NavLink>
        </div>

        <div className={style.navCenter}>
          <NavLink to="/chat" className={style.navLink}>Chat</NavLink>
          <NavLink to="/profile" className={style.navLink}>Profile</NavLink>
        </div>

        <div className={style.navRight}>
          <NavLink to="/upload-chats" className={style.ctaButton}>Create now</NavLink>
        </div>
      </nav>
    );
  };

export default NavBar;